import {
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, Settings, LogOut, ChevronDown } from "lucide-react";
import "./avatar.scss";
import { useAuth } from "@/composables/auth";
import { NotificationBell } from "@/components/molecules/notifications/notification-bell";
import { useAuthStore } from "@/context";

interface UiAvatarProps {
  fullname: string;
  role: string;
}
export function UiAvatar({ fullname, role }: UiAvatarProps) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const profilePicture = useAuthStore((state) => state.profilePicture);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
    navigate("/connexion");
  };

  const handleProfileClick = () => {
    handleClose();
    navigate("/dashboard/profil");
  };

  const handleNotification = () => {
    handleClose();
    navigate("/dashboard/profil/notifications");
  };

  return (
    <div className="ui-avatar flex gap-1 items-center">
      <NotificationBell />
      <IconButton
        onClick={handleClick}
        className="ui-avatar-button"
        sx={{
          padding: 1,
          borderRadius: 2,
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        <div className="ui-avatar-content">
          {/*<div className="ui-avatar-image">*/}
          {/*  <Avatar*/}
          {/*    alt={fullname}*/}
          {/*    src={profilePicture || "/assets/images/avatar.png"}*/}
          {/*    sx={{ width: 40, height: 40 }}*/}
          {/*  />*/}
          {/*</div>*/}
          {/*<div className="ui-avatar-info">*/}
          {/*  <div className="ui-avatar-name">{fullname}</div>*/}
          {/*  <div className="ui-avatar-role">{role}</div>*/}
          {/*</div>*/}
          <ChevronDown
            size={16}
            style={{
              marginLeft: 8,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          />
        </div>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
            mt: 1.5,
            minWidth: 200,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleProfileClick} sx={{ px: 2, py: 1.5 }}>
          <User size={18} style={{ marginRight: 12 }} />
          <Typography variant="body2">Mon profil</Typography>
        </MenuItem>

        <MenuItem onClick={handleNotification} sx={{ px: 2, py: 1.5 }}>
          <Settings size={18} style={{ marginRight: 12 }} />
          <Typography variant="body2">Notifications</Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={handleLogout}
          sx={{
            px: 2,
            py: 1.5,
            color: "error.main",
            "&:hover": {
              backgroundColor: "error.light",
              color: "error.contrastText",
            },
          }}
        >
          <LogOut size={18} style={{ marginRight: 12 }} />
          <Typography variant="body2">Se déconnecter</Typography>
        </MenuItem>
      </Menu>
    </div>
  );
}
